export function collectSubGroups (item, showMenu) {
  const menus = item.menus
  if (!menus) return []
  const res = []
  menus.forEach(menu => {
    if (!menu.subGroup || !showMenu(menu) || !menu.submenus) return
    let hasVisible = false
    menu.submenus.forEach(submenu => {
      if (showMenu(submenu)) {
        hasVisible = true
      }
    })
    if (hasVisible && !res.includes(menu.subGroup)) {
      res.push(menu.subGroup)
    }
  })
  return res
}

export function collectL3Groups (item, subGroup, showMenu, getLabel, staredList = []) {
  if (!item || !subGroup) return []
  const menus = item.menus || []
  return menus
    .filter(menu => menu.subGroup === subGroup && showMenu(menu) && menu.submenus)
    .map(menu => ({
      title: getLabel(menu.meta),
      submenus: menu.submenus
        .filter(submenu => showMenu(submenu))
        .map(submenu => ({
          title: getLabel(submenu.meta),
          path: submenu.path,
          menu: submenu,
          stared: staredList.includes(submenu.path),
        })),
    }))
    .filter(group => group.submenus.length > 0)
}

export function getFirstL3Link (item, subGroup, showMenu, getLabel) {
  const groups = collectL3Groups(item, subGroup, showMenu, getLabel)
  for (const group of groups) {
    if (group.submenus.length > 0) {
      return group.submenus[0]
    }
  }
  return null
}

export function hasSubGroups (item, showMenu) {
  return collectSubGroups(item, showMenu).length > 0
}
